export default __webpack_public_path__ + "static/media/camera.bf8c6674.png";